import API_BASE_URL from '../config/api';

const getImageUrl = (imageUrl) => {
    if (!imageUrl) {
        return '';
    }

    if (
        imageUrl.startsWith('http://') ||
        imageUrl.startsWith('https://')
    ) {
        return imageUrl;
    }

    if (imageUrl.startsWith('/')) {
        return `${API_BASE_URL}${imageUrl}`;
    }

    return `${API_BASE_URL}/${imageUrl}`;
};

export default getImageUrl;